import ne, { STORAGE_KEYS as s } from "../managers/storage-manager.js";
export function isDisabled() {
  return !!new ne.se(null, !0).gr(s.me);
}
